module.exports = __webpack_public_path__ + "img/call_white.56adeb07.svg";